import React from 'react'
import styles from './EventCard.scss'
import { MountOnHoverCard } from 'common/hovercards/MountOnHoverCard'
import { CardBody } from 'common/hovercards/CardBody'
import { clampStringWords } from 'lib/utils'
import { urls } from 'lib/urls'
import moment from 'moment'
import { formatDateRange } from '@qrohlf/smart-date'

export class EventCard extends React.PureComponent {
  render () {
    const { children, event } = this.props
    const start = event.startsOn
    const end = event.endsOn

    let timeSpan = ''
    if (end && !moment(end).isSame(start, 'day')) {
      timeSpan = formatDateRange(start, end, { includeTime: !event.allDay })
    } else {
      if (event.allDay) {
        timeSpan = 'All day'
      } else {
        timeSpan = moment(event.startsAt).format('h:mmA')
      }
    }

    const content = <div className={styles.content}>
      <div className={styles.left}>
        {timeSpan && <div>{timeSpan}</div>}
        {event.location && <div>{event.location}</div>}
        {event.userName && <div>by {event.userName}</div>}
        {event.desc && <div>{clampStringWords(event.desc, 140)}</div>}
      </div>
      <div className={styles.right}>
        <img src={urls.photos.centi(event.highlightedPhotoId)} />
      </div>
    </div>

    return (
      <MountOnHoverCard wrappedChildren={children}>
        <CardBody
          header={event.name}
          content={content} />
      </MountOnHoverCard>
    )
  }
}
